import OriginList from '@/components/origin/OriginList'
import OriginCreate from '@/components/origin/OriginCreate'
import OriginEdit from '@/components/origin/OriginEdit'
import OriginVue from '@/components/origin/OriginVue'

export default [
  {
    path: '/origines',
    name: 'OriginList',
    component: OriginList,
    meta: {
      parentName: 'Home',
      requiresAuth: true,
      needProfile: ['admin']
    }
  },
  {
    path: '/origines/creation',
    name: 'OriginCreate',
    component: OriginCreate,
    meta: {
      parentName: 'OriginList',
      requiresAuth: true,
      needProfile: ['admin']
    }
  },
  {
    path: '/origines/:id',
    name: 'OriginVue',
    component: OriginVue,
    meta: {
      parentName: 'OriginList',
      requiresAuth: true,
      needProfile: ['admin'],
      maxHeight: true
    }
  },
  {
    path: '/origines/:id/edition',
    name: 'OriginEdit',
    component: OriginEdit,
    meta: {
      parentName: 'OriginVue',
      requiresAuth: true,
      needProfile: ['admin'],
      maxHeight: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/originRouter.js